/* HUFT Kuwait — minimum order progress bar  (v5: add-on nudge)
   Shows how far the cart is from the 5.000 KWD checkout minimum.
   Renders sitewide as a sticky bar, and inline in the cart drawer and cart page.
   v5 adds one-tap add-on chips inside the drawer / cart-page bar:
     - under the minimum: items that get the basket over the floor in one tap
     - at the floor (5.000-6.999): small extras, because delivery is 1.500 on the order
   Pure overlay: touches no product URLs, no Liquid templates, no cart data. */
(function () {
  'use strict';

  var MIN_KWD   = 5.000;          // merchandise subtotal, excludes delivery
  var NUDGE_MAX = 7.000;          // show add-on chips while subtotal < this (delivery 1.500 is >20% of basket below it)
  var CURRENCY  = 'KWD';
  var MINOR     = 100;            // Shopify cart.js reports KWD in hundredths (4.000 KWD -> 400), verified live 20 Sep 2026
  var ORANGE    = '#FF6D1F';
  var GREEN     = '#1E8E5A';
  var KEY       = 'huft-mob';     // dismiss key for the sticky bar, per session
  var CHIPS     = 2;              // add-on chips shown at once

  var T = {
    en: {
      remaining: function (v) { return 'Add ' + v + ' KD more to check out'; },
      ready:     'Minimum reached — you can check out',
      note:      'Minimum order 5.000 KD, delivery not included',
      close:     'Dismiss',
      nudgeLow:  'One tap gets you there:',
      nudgeAt:   'Delivery is 1.500 KD on this order — add a little extra?',
      add:       'Add',
      adding:    '…',
      added:     'Added ✓',
      kd:        'KD'
    },
    ar: {
      remaining: function (v) { return 'أضف ' + v + ' د.ك لإتمام الطلب'; },
      ready:     'تم الوصول للحد الأدنى — يمكنك إتمام الطلب',
      note:      'الحد الأدنى للطلب 5.000 د.ك، بدون رسوم التوصيل',
      close:     'إغلاق',
      nudgeLow:  'بضغطة واحدة تصل للحد الأدنى:',
      nudgeAt:   'رسوم التوصيل 1.500 د.ك على هذا الطلب — أضف شيئاً صغيراً؟',
      add:       'أضف',
      adding:    '…',
      added:     'تمت الإضافة ✓',
      kd:        'د.ك'
    }
  };

  /* Curated add-ons: cheap, single-unit, live. Price / stock / image are read live from
     /products/<handle>.js at run time, so a sold-out item drops out on its own.
     `v` is the single-unit variant id (fallback: first available "Pack of 1"). */
  var ADDONS = {
    cat: [
      { h: 'huft-meowsi-tuna-chicken-in-broth-grain-free-cat-wet-food-80-gm', v: 41895630241867, en: 'Tuna & Chicken can', ar: 'تونة ودجاج (علبة)' },
      { h: 'meowsi-by-huft-catnip-with-salmon-chicken-soft-cat-treats-50-gm', v: 41895579844683, en: 'Catnip soft treats', ar: 'مكافآت بالنعناع البري' },
      { h: 'meowsi-by-huft-skin-coat-salmon-chicken-mousse-cat-wet-food-70-gm', v: 41895623426123, en: 'Salmon & Chicken mousse', ar: 'موس سلمون ودجاج' },
      { h: 'meowsi-by-huft-chicken-fish-psyllium-husk-power-bites-cat-treats-50-gm', v: 41895618871371, en: 'Power Bites treats', ar: 'باور بايتس' },
      { h: 'meowsi-by-huft-chicken-breast-with-duck-mousse-canned-cat-wet-food-80-gm', v: 41895593902155, en: 'Chicken & Duck mousse', ar: 'موس دجاج وبط' },
      { h: 'meowsi-by-huft-tuna-shrimp-mousse-canned-cat-wet-food-80-gm', v: 41895640105035, en: 'Tuna & Shrimp mousse', ar: 'موس تونة وروبيان' }
    ],
    dog: [
      { h: 'huft-yakies-vegetarian-organic-chew-bone', v: 40843897634891, en: 'Yakies chew bone (S)', ar: 'عظمة ياكيز للمضغ (S)' },
      { h: 'huft-yum-nums-soft-chewy-sticks-real-chicken-treat-for-dogs-75g', v: 40843901075531, en: 'Yum Nums chicken sticks', ar: 'يم نمز أصابع دجاج' },
      { h: 'huft-organic-healing-balm', v: 40843895144523, en: 'Organic healing balm', ar: 'بلسم عضوي معالج' },
      { h: 'huft-yum-nums-soft-chewy-sticks-pumpkin-with-real-chicken-treat-for-dogs-75g', v: 40843901304907, en: 'Yum Nums pumpkin sticks', ar: 'يم نمز أصابع يقطين' },
      { h: 'huft-yakies-vegetarian-natural-chew-bone-apple', v: 41273415106635, en: 'Yakies apple chew (M)', ar: 'عظمة ياكيز بالتفاح (M)' }
    ],
    both: [
      { h: 'huft-anti-tick-and-flea-powder-for-dog-and-cat', v: 40843896389707, en: 'Anti-tick & flea powder', ar: 'بودرة ضد القراد والبراغيث' },
      { h: 'huft-quick-clot-powder-for-dogs-cats', v: 41895653441611, en: 'Quick Clot powder', ar: 'بودرة كويك كلوت' }
    ]
  };
  var CAT_RE = new RegExp('cat|meowsi|kitten|purr', 'i');
  var DOG_RE = new RegExp('dog|puppy|yakies|yimt|yum nums|yum-nums|sara|hearty|jammies|bubble|barking|aqua paws|aqua-paws', 'i');

  function isRTL() {
    return document.documentElement.getAttribute('dir') === 'rtl' ||
           document.body.classList.contains('rtl') ||
           (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  }
  function t() { return isRTL() ? T.ar : T.en; }
  function fmt(n) { return n.toFixed(3); }

  /* ---------- styles ---------- */
  function injectCSS() {
    if (document.getElementById('huft-mob-css')) return;
    var s = document.createElement('style');
    s.id = 'huft-mob-css';
    s.textContent = [
      '.huft-mob{font-family:inherit;box-sizing:border-box}',
      '.huft-mob *{box-sizing:border-box}',
      '.huft-mob-inline{margin:12px 0;padding:12px 14px;border:1px solid rgba(0,0,0,.08);',
        'border-radius:8px;background:#FBF7F1}',
      '.huft-mob-sticky{position:fixed;left:12px;right:12px;max-width:560px;margin:0 auto;z-index:9998;',
        'bottom:calc(env(safe-area-inset-bottom,0px) + var(--huft-mob-lift,12px));padding:12px 14px 13px;',
        'background:#fff;border:1px solid rgba(20,17,13,.07);border-radius:14px;',
        'box-shadow:0 8px 28px rgba(20,17,13,.16);visibility:hidden;transform:translateY(calc(100% + 48px));',
        'transition:transform .32s cubic-bezier(.3,1,.3,1)}',
      '.huft-mob-sticky .huft-mob-sub{display:none}',
      '.huft-mob-sticky .huft-mob-row{margin-bottom:8px}',
      '.huft-mob-sticky.is-in{visibility:visible;transform:translateY(0)}',
      '.huft-mob-row{display:flex;align-items:center;gap:10px;margin-bottom:7px}',
      '.huft-mob-msg{flex:1;font-size:13.5px;line-height:1.4;font-weight:700;color:#14110D}',
      '.huft-mob-sub{font-size:11.5px;line-height:1.4;color:#8C877D;margin-top:5px}',
      '.huft-mob-track{position:relative;height:7px;border-radius:99px;background:#EDE7DC;overflow:hidden}',
      '.huft-mob-fill{position:absolute;top:0;bottom:0;width:0;border-radius:99px;',
        'background:' + ORANGE + ';transition:width .4s cubic-bezier(.3,1,.3,1)}',
      '.huft-mob.is-ready .huft-mob-fill{background:' + GREEN + '}',
      '.huft-mob.is-ready .huft-mob-msg{color:' + GREEN + '}',
      '.huft-mob-x{flex:0 0 auto;border:0;background:transparent;cursor:pointer;',
        'font-size:19px;line-height:1;color:#8C877D;padding:2px 4px}',
      'html[dir="rtl"] .huft-mob-fill,body.rtl .huft-mob-fill{left:auto;right:0}',
      '.huft-bms{font-weight:800;letter-spacing:.2px;background:linear-gradient(100deg,currentColor 0%,currentColor 42%,#FFD66B 50%,currentColor 58%,currentColor 100%);',
        'background-size:220% 100%;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;',
        'animation:huftShine 2.6s linear infinite}',
      '@keyframes huftShine{0%{background-position:120% 0}100%{background-position:-120% 0}}',
      '@media(prefers-reduced-motion:reduce){.huft-bms{animation:none;background:none;-webkit-text-fill-color:currentColor}}',
      '@media(max-width:1024.5px){body.huft-mob-on .back-to-top{bottom:calc(env(safe-area-inset-bottom,0px) + var(--huft-mob-lift,12px) + var(--huft-mob-h,60px) + 12px)!important}}',
      /* add-on chips (inline bars only) */
      '.huft-mob-add{display:none;margin-top:10px;padding-top:10px;border-top:1px dashed rgba(20,17,13,.12)}',
      '.huft-mob-add.is-on{display:block}',
      '.huft-mob-add-h{font-size:12.5px;line-height:1.35;font-weight:700;color:#14110D;margin:0 0 8px}',
      '.huft-mob-chips{display:flex;gap:8px}',
      '.huft-mob-chip{flex:1 1 0;min-width:0;display:flex;align-items:center;gap:8px;padding:6px 8px 6px 6px;',
        'background:#fff;border:1px solid rgba(20,17,13,.1);border-radius:10px}',
      '.huft-mob-chip img{flex:0 0 auto;width:40px;height:40px;border-radius:7px;object-fit:cover;background:#F1ECE3}',
      '.huft-mob-chip-t{flex:1 1 auto;min-width:0}',
      '.huft-mob-chip-n{font-size:11.5px;line-height:1.25;font-weight:600;color:#14110D;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.huft-mob-chip-p{font-size:11px;line-height:1.3;color:#8C877D;margin-top:2px}',
      '.huft-mob-chip-b{flex:0 0 auto;border:0;border-radius:99px;background:' + ORANGE + ';color:#fff;font-weight:700;',
        'font-size:12px;line-height:1;padding:8px 11px;cursor:pointer;white-space:nowrap;font-family:inherit}',
      '.huft-mob-chip-b:disabled{opacity:.55;cursor:default}',
      '.huft-mob-chip-b.is-done{background:' + GREEN + '}',
      '@media(max-width:380px){.huft-mob-chip img{display:none}.huft-mob-chip-b{padding:8px 9px}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- markup ---------- */
  function build(kind) {
    var w = document.createElement('div');
    w.className = 'huft-mob huft-mob-' + kind;
    w.setAttribute('role', 'status');
    w.setAttribute('aria-live', 'polite');
    w.innerHTML =
      '<div class="huft-mob-row">' +
        '<div class="huft-mob-msg"></div>' +
        (kind === 'sticky' ? '<button type="button" class="huft-mob-x" aria-label="' + t().close + '">×</button>' : '') +
      '</div>' +
      '<div class="huft-mob-track"><div class="huft-mob-fill"></div></div>' +
      '<div class="huft-mob-sub"></div>' +
      (kind === 'inline' ? '<div class="huft-mob-add"><p class="huft-mob-add-h"></p><div class="huft-mob-chips"></div></div>' : '');
    if (kind === 'sticky') {
      w.querySelector('.huft-mob-x').addEventListener('click', function () {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        w.classList.remove('is-in');
      });
    }
    return w;
  }

  function paint(el, subtotal) {
    var L = t();
    var pct = Math.max(0, Math.min(100, (subtotal / MIN_KWD) * 100));
    var ready = subtotal >= MIN_KWD;
    var msg = ready ? L.ready : L.remaining(fmt(MIN_KWD - subtotal));
    if (el.classList.contains('is-ready') !== ready) el.classList.toggle('is-ready', ready);
    var fill = el.querySelector('.huft-mob-fill');
    var w = pct + '%';
    if (fill.style.width !== w) fill.style.width = w;
    var m = el.querySelector('.huft-mob-msg');
    if (m.textContent !== msg) m.textContent = msg;          // write only on change
    var sub = el.querySelector('.huft-mob-sub');
    if (sub.textContent !== L.note) sub.textContent = L.note;
    if (el.classList.contains('huft-mob-inline')) paintNudge(el, subtotal);
  }

  /* ---------- add-on nudge (inline bars only) ---------- */
  var lastItems = [];          // cart line items from the most recent /cart.js read
  var catalog   = {};          // handle -> { ok, price, img, vid, avail } (live product data)
  var loads     = {};          // handle -> Promise
  var CACHE_KEY = 'huft-mob-cat';
  var CACHE_TTL = 10 * 60 * 1000;

  function storeRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return;
      var c = JSON.parse(raw);
      if (c && c.t && Date.now() - c.t < CACHE_TTL && c.d) { for (var k in c.d) catalog[k] = c.d[k]; }
    } catch (e) {}
  }
  function writeCache() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: catalog })); } catch (e) {}
  }
  function imgUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function loadProduct(entry) {
    var h = entry.h;
    if (catalog[h]) return Promise.resolve(catalog[h]);
    if (loads[h]) return loads[h];
    loads[h] = fetch(storeRoot() + 'products/' + h + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var rec = { ok: false };
        if (p && p.variants && p.variants.length) {
          var v = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === entry.v) { v = p.variants[i]; break; } }
          if (!v) { for (var j = 0; j < p.variants.length; j++) { var t2 = p.variants[j].title || ''; if (t2.indexOf('Pack of 1') > -1 && p.variants[j].available) { v = p.variants[j]; break; } } }
          if (v) {
            var im = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
            rec = { ok: true, vid: v.id, price: (v.price || 0) / MINOR, avail: !!v.available, img: imgUrl(im) };
          }
        }
        catalog[h] = rec; writeCache();
        return rec;
      })
      .catch(function () { catalog[h] = { ok: false }; return catalog[h]; });
    return loads[h];
  }

  function speciesOf(items) {
    var cat = false, dog = false;
    for (var i = 0; i < items.length; i++) {
      var s = ((items[i].handle || '') + ' ' + (items[i].product_title || items[i].title || '') + ' ' + (items[i].product_type || ''));
      if (CAT_RE.test(s)) cat = true;
      if (DOG_RE.test(s)) dog = true;
    }
    return { cat: cat, dog: dog };
  }
  function poolFor(sp) {
    var out = [];
    if (sp.cat && sp.dog) {                       // mixed basket: alternate cat / dog
      var n = Math.max(ADDONS.cat.length, ADDONS.dog.length);
      for (var i = 0; i < n; i++) { if (ADDONS.cat[i]) out.push(ADDONS.cat[i]); if (ADDONS.dog[i]) out.push(ADDONS.dog[i]); }
    } else if (sp.cat) { out = ADDONS.cat.slice(); }
    else if (sp.dog)   { out = ADDONS.dog.slice(); }
    else { out = ADDONS.both.slice().concat(ADDONS.dog.slice(0, 2), ADDONS.cat.slice(0, 2)); }
    return out.concat(ADDONS.both);
  }
  function inCart(handle) {
    for (var i = 0; i < lastItems.length; i++) { if (lastItems[i].handle === handle) return true; }
    return false;
  }
  function pickChips(subtotal, pool) {
    var cands = [];
    for (var i = 0; i < pool.length; i++) {
      var e = pool[i], c = catalog[e.h];
      if (!c || !c.ok || !c.avail || inCart(e.h)) continue;
      var seen = false;
      for (var k = 0; k < cands.length; k++) { if (cands[k].h === e.h) { seen = true; break; } }
      if (!seen) cands.push({ h: e.h, en: e.en, ar: e.ar, vid: c.vid, price: c.price, img: c.img, ord: i });
    }
    if (subtotal < MIN_KWD) {                     // under the floor: one tap should clear it
      var need = MIN_KWD - subtotal;
      cands.sort(function (a, b) {
        var ra = a.price >= need ? 0 : 1, rb = b.price >= need ? 0 : 1;
        if (ra !== rb) return ra - rb;                             // items that clear the floor first
        if (ra === 0) return a.ord - b.ord;                        // ...in curated order (cheap-first per species)
        return b.price - a.price || a.ord - b.ord;                 // otherwise the biggest step
      });
    } else {
      cands.sort(function (a, b) { return a.ord - b.ord; });       // curated order
    }
    // take the first, then prefer a different price tier for the next chip (a can AND a treat, not two cans)
    var out = [];
    while (cands.length && out.length < CHIPS) {
      var pick = 0;
      if (out.length) { for (var j = 0; j < cands.length; j++) { if (cands[j].price !== out[out.length - 1].price) { pick = j; break; } } }
      out.push(cands.splice(pick, 1)[0]);
    }
    return out;
  }

  var poolLoading = false;
  function paintNudge(el, subtotal) {
    var box = el.querySelector('.huft-mob-add');
    if (!box) return;
    var L = t();
    var want = lastItems.length > 0 && subtotal > 0 && subtotal < NUDGE_MAX;
    if (!want) { if (box.classList.contains('is-on')) { box.classList.remove('is-on'); box.__huftSig = ''; } return; }
    if (el.__huftHold && Date.now() < el.__huftHold) return;      // let "Added ✓" be seen
    var pool = poolFor(speciesOf(lastItems));
    var missing = pool.filter(function (e) { return !catalog[e.h]; });
    if (missing.length) {
      if (!poolLoading) {
        poolLoading = true;
        Promise.all(missing.map(loadProduct)).then(function () {
          poolLoading = false;
          document.querySelectorAll('.huft-mob-inline').forEach(function (b) { paintNudge(b, last); });
        });
      }
      return;                                                     // render once data is in
    }
    var chips = pickChips(subtotal, pool);
    if (!chips.length) { box.classList.remove('is-on'); box.__huftSig = ''; return; }
    var low = subtotal < MIN_KWD;
    var sig = (low ? 'L' : 'A') + '|' + chips.map(function (c) { return c.vid; }).join(',') + '|' + (isRTL() ? 'ar' : 'en');
    if (box.__huftSig === sig) return;
    box.__huftSig = sig;
    box.querySelector('.huft-mob-add-h').textContent = low ? L.nudgeLow : L.nudgeAt;
    var wrap = box.querySelector('.huft-mob-chips');
    wrap.innerHTML = '';
    chips.forEach(function (c) {
      var chip = document.createElement('div');
      chip.className = 'huft-mob-chip';
      chip.innerHTML =
        (c.img ? '<img alt="" src="' + c.img + '">' : '') +
        '<div class="huft-mob-chip-t"><div class="huft-mob-chip-n"></div><div class="huft-mob-chip-p"></div></div>' +
        '<button type="button" class="huft-mob-chip-b"></button>';
      chip.querySelector('.huft-mob-chip-n').textContent = isRTL() ? c.ar : c.en;
      chip.querySelector('.huft-mob-chip-p').textContent = fmt(c.price) + ' ' + L.kd;
      var btn = chip.querySelector('.huft-mob-chip-b');
      btn.textContent = L.add;
      btn.setAttribute('aria-label', L.add + ' ' + (isRTL() ? c.ar : c.en));
      btn.addEventListener('click', function () { addToCart(c, btn, el); });
      wrap.appendChild(chip);
    });
    box.classList.add('is-on');
  }

  function addToCart(c, btn, el) {
    var L = t();
    btn.disabled = true; btn.textContent = L.adding;
    var onCart = onCartPage();
    var main = document.getElementById('main-cart-items');
    var sectionId = onCart ? (main && main.dataset.id) : 'minicart-form';
    var body = { id: c.vid, quantity: 1 };
    if (sectionId) { body.sections = sectionId; body.sections_url = location.pathname; }
    fetch(storeRoot() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'add failed');
        btn.textContent = L.added; btn.classList.add('is-done');
        el.__huftHold = Date.now() + 900;
        var html = res.j && res.j.sections && sectionId ? res.j.sections[sectionId] : null;
        swapSection(onCart, html);
        syncHeader();
        setTimeout(refresh, 150);
      })
      .catch(function () { btn.disabled = false; btn.textContent = L.add; });
  }

  /* re-render the theme's cart markup the same way the theme does (Section Rendering API) */
  function swapSection(onCart, html) {
    if (!html) {
      if (onCart) { location.reload(); return; }
      fetch(storeRoot() + '?sections=minicart-form', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j['minicart-form']) swapSection(false, j['minicart-form']); else location.reload(); })
        .catch(function () { location.reload(); });
      return;
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (onCart) {
      var s = doc.querySelector('.js-contents'), d = document.querySelector('#main-cart-items .js-contents');
      if (s && d) d.innerHTML = s.innerHTML; else { location.reload(); return; }
      var ts = doc.querySelector('.cart-info .totals'), td = document.querySelector('.cart-info .totals');
      if (ts && td) td.innerHTML = ts.innerHTML;
    } else {
      var s2 = doc.getElementById('minicart-form'), d2 = document.getElementById('minicart-form');
      if (s2 && d2) d2.innerHTML = s2.innerHTML; else { location.reload(); return; }
    }
    try { if (window.BlsLazyloadImg && window.BlsLazyloadImg.init) window.BlsLazyloadImg.init(); } catch (e) {}
  }

  function syncHeader() {
    fetch(storeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.cart-count').forEach(function (n) {
          n.innerHTML = n.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : (cart.item_count > 100 ? '~' : cart.item_count);
        });
        var htp = document.querySelector('header-total-price');
        if (htp && htp.updateTotal) { try { htp.updateTotal(cart); } catch (e) {} }
      })
      .catch(function () {});
  }

  /* ---------- placement ---------- */
  var INLINE_ANCHORS = [
    'form[action*="/cart"] button[name="checkout"]',
    'button[name="checkout"]',
    '.cart__checkout-button',
    '.mini_cart_footer',
    '.cart-drawer__footer'
  ];

  function placeInline(subtotal) {
    var n = 0;
    INLINE_ANCHORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (btn) {
        if (btn.closest('.huft-mob')) return;
        var host = btn.closest('form') || btn.parentNode;
        if (!host || host.__huftMobDone) return;
        host.__huftMobDone = true;                 // one bar per host, ever
        var bar = build('inline');
        host.__huftMobBar = bar;
        btn.parentNode.insertBefore(bar, btn);
        n++;
      });
    });
    document.querySelectorAll('.huft-mob-inline').forEach(function (bar) { paint(bar, subtotal); });
    return n;
  }

  var sticky = null;
  var lastCart = null;   // {subtotal, hasItems} from the most recent /cart.js read

  function overlayOpen() {
    var h = document.documentElement.classList;
    return h.contains('open-drawer') || h.contains('open-minicart') || h.contains('open-search') ||
           !!document.querySelector('.minicart.open, cart-notification.open, .bls__drawer.open');
  }
  function onCartPage() {
    return document.body.classList.contains('template-cart') || new RegExp('^/([a-z]{2}/)?cart/?$').test(location.pathname);
  }

  function placeSticky(subtotal, hasItems) {
    lastCart = { subtotal: subtotal, hasItems: hasItems };
    applySticky();
  }

  /* decide visibility from the last cart read plus the current page state */
  function applySticky() {
    if (!lastCart) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (!sticky) { sticky = build('sticky'); document.body.appendChild(sticky); }
    paint(sticky, lastCart.subtotal);
    var show = lastCart.hasItems && lastCart.subtotal > 0 && lastCart.subtotal < MIN_KWD &&
               !dismissed && !overlayOpen() && !onCartPage();
    sticky.classList.toggle('is-in', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('huft-mob-on', show);
    if (show) document.documentElement.style.setProperty('--huft-mob-h', sticky.offsetHeight + 'px');
    updateLift();
  }

  /* keep the card clear of the theme's mobile nav bar when that bar is actually visible */
  function updateLift() {
    var lift = window.innerWidth > 1024 ? 20 : 12;
    var nav = document.querySelector('.mobile-navigation-bar');
    if (nav) {
      var cs = getComputedStyle(nav);
      var shown = nav.offsetHeight > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.2;
      if (shown) lift = nav.offsetHeight + 10;
    }
    document.documentElement.style.setProperty('--huft-mob-lift', lift + 'px');
  }
  var liftTimer = null;
  function liftSoon() { if (liftTimer) return; liftTimer = setTimeout(function () { liftTimer = null; updateLift(); }, 200); }

  /* ---------- data ---------- */
  var last = -1;
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if ((cart.currency || '').toUpperCase() !== CURRENCY) {
          if (sticky) sticky.classList.remove('is-in');
          return;
        }
        var subtotal = (cart.items_subtotal_price || 0) / MINOR;
        last = subtotal;
        lastItems = cart.items || [];
        injectCSS();
        placeInline(subtotal);
        placeSticky(subtotal, (cart.item_count || 0) > 0);
      })
      .catch(function () {});
  }

  /* ---------- cart-change detection ---------- */
  var CART_RE = new RegExp('/cart/(add|change|update|clear)', 'i');
  function hook() {
    var f = window.fetch;
    if (f && !f.__huftMOB) {
      var wrapped = function () {
        var url = arguments[0];
        url = (typeof url === 'string') ? url : (url && url.url) || '';
        return f.apply(this, arguments).then(function (res) {
          if (CART_RE.test(url)) setTimeout(refresh, 120);
          return res;
        });
      };
      wrapped.__huftMOB = true;
      window.fetch = wrapped;
    }
    var open = XMLHttpRequest.prototype.open;
    if (!open.__huftMOB) {
      var patched = function (m, u) {
        if (CART_RE.test(u || '')) this.addEventListener('load', function () { setTimeout(refresh, 120); });
        return open.apply(this, arguments);
      };
      patched.__huftMOB = true;
      XMLHttpRequest.prototype.open = patched;
    }
    ['cart:updated', 'cart:refresh', 'cart:change', 'CartDrawer:open', 'cart-drawer:open']
      .forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 120); }); });
  }

  var pending = false;
  function boot() {
    injectCSS();
    readCache();
    hook();
    refresh();
    // re-attach when the drawer or cart section is re-rendered; ignore our own writes, coalesce bursts
    var mo = new MutationObserver(function (records) {
      if (pending || last < 0) return;
      var external = false;
      for (var i = 0; i < records.length; i++) {
        var tgt = records[i].target;
        if (!(tgt && tgt.nodeType === 1 && tgt.closest && tgt.closest('.huft-mob'))) { external = true; break; }
      }
      if (!external) return;
      pending = true;
      setTimeout(function () { pending = false; placeInline(last); }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // "Buy more, save more" announcement: keep the shimmer even if the editor strips the class
    document.querySelectorAll('#topbar .swiper-slide').forEach(function (sl) {
      if (sl.querySelector('.huft-bms')) return;
      var tx = sl.textContent || '';
      if (/buy more, save more|اشترِ أكثر/i.test(tx)) {
        var strong = sl.querySelector('strong, b');
        if (strong) strong.classList.add('huft-bms');
      }
    });
    var classTick = false;
    new MutationObserver(function () {
      if (classTick) return;
      classTick = true;
      setTimeout(function () { classTick = false; applySticky(); }, 16);
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', liftSoon, { passive: true });
    window.addEventListener('resize', liftSoon);
    updateLift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
